<template>
  <section class="d-flex gap-4 flex-wrap">
    <div
      v-for="card in data"
      :key="card?.text"
      :class="{
        'd-none': $store.getters['enums/is_not_permitted'](card?.permission),
      }"
    >
      <div
        class="card-body cursor-pointer"
        v-if="!$store.getters['enums/is_not_permitted'](card?.permission)"
        @click="moveTo(`/${card?.route}`)"
      >
        <img :src="getImgUrl(card?.icon)" v-if="card?.icon" alt="card logo" class="mb-4" />
        <h2>
          <span>{{ $t(card?.text) }}</span>
        </h2>
        <div class="card-body__footer d-flex justify-content-between flex-wrap">
          <span>{{ $t(card?.subText) }}</span>
          <div class="my-1 ms-auto">
            <img
              src="@/assets/images/icons/arrow-right-quick.png"
              :class="{ '-scale-1': isLangRtl }"
              alt="arrow right"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      data: [
        {
          text: 'drivers-management',
          permission: 'driverTab',
          route: 'drivers',
          icon: 'drivers-quick',
          subText: 'drivers-management-sub',
        },
        {
          text: 'vehicle-management',
          permission: 'vehicleTab',
          route: 'vehicles',
          icon: 'vehicle-quick',
          subText: 'vehicle-management-sub',
        },
        {
          text: 'manage-trips',
          permission: 'operationsContractedJourneyTab',
          route: 'manage-trips',
          icon: 'manage-quick',
          subText: 'manage-trips-sub',
        },
        {
          text: 'reservations-management',
          permission: 'operationsReservationTab',
          route: 'operations/list',
          icon: 'reservations-quick',
          subText: 'reservations-management-sub',
        },
        {
          text: 'clients-management',
          permission: 'clientTab',
          route: 'clients',
          icon: 'clients-quick',
          subText: 'clients-management-sub',
        },
      ],
    }
  },
  methods: {
    moveTo(route) {
      if (route) this.$router.push(route).catch(() => {})
    },
    getImgUrl(imageName) {
      return require(`@/assets/images/${imageName}.svg`)
    },
  },
}
</script>
<style lang="scss" scoped>
.card-body {
  padding-inline: 18px;
  padding-block: 16px;
  background-color: var(--color-01);
  border: 1px solid var(--color-142);
  border-radius: 10px;
  width: 390px;
  margin-block-start: 16px;
  box-shadow: 0px 2px 6px 0px #00000021;
  flex: 0 1 auto;
  height: 100%;

  &:hover {
    background: rgba(var(--color-142), 0.25);
  }
  h2 {
    span {
      font-size: 25px;
      font-weight: 700;
      line-height: 53px;
      margin-inline-end: 12px;
    }
  }
  &__footer {
    span {
      font-size: 14px;
      max-width: 251px;
    }
  }
}
</style>
